import { Constructor } from "../mixins/constructor";
import { Address } from "./address";

export interface AgencyBlocAddress extends Address {
  entityID: number;
  entityType: string;
}

export function HasAgencyBlocAddresses<T extends Constructor<{}>>(Base: T = class {} as any) {
  return class extends Base {
    public addresses: AgencyBlocAddress[] = [];
  }
}
